<template>
    <div class="finish">
        <div v-if="$route.query.orderStatus == 'success'">
          <img src="@/assets/success.png">
          <p style="margin-top:5px;color:#00c020;">{{$t('paymentSuccess')}}</p>
          <p>{{$t('thxForBuy')}}</p> 
          <van-button size="large" round type="danger" @click="toConsume">{{$t('checkOrder')}}</van-button>
          <van-button size="large" round type="danger" style="margin-top: 20px;" @click="toStore">{{$t('backToStore')}}</van-button>
        </div>
        <div v-if="$route.query.orderStatus == 'finished'">
          <img src="@/assets/finish.png">
          <p style="margin-top:5px;color:#fea52d;">{{$t('pending')}}</p>
          <p>{{$t('pendWaiting')}}</p> 
          <van-button size="large" round type="danger" @click="toConsume">{{$t('checkOrder')}}</van-button>
          <van-button size="large" round type="danger" style="margin-top: 20px;" @click="toStore">{{$t('backToStore')}}</van-button>
        </div>
        <div v-if="$route.query.orderStatus == 'error'">
          <p style="margin-top:5px;color:#e60012;">{{$t('payError')}}</p>
          <img src="@/assets/error.png">
          <p>{{$t('errorAgain')}}</p> 
          <van-button size="large" round type="danger" @click="toConsume">{{$t('checkOrder')}}</van-button>
          <van-button size="large" round type="danger" style="margin-top: 20px;" @click="toStore">{{$t('payAgain')}}</van-button>
        </div>
        <p>{{$t('backMain', {msg: time})}}</p>
    </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import { ref } from 'vue';
import {mapGetters, mapActions} from 'vuex';
import { Toast } from 'vant';

export default {
  name: 'Finish',
  data(){
    return{
        storage: localStorage.getItem('storage') ? JSON.parse(localStorage.getItem('storage')) : [],
        role: localStorage.getItem('role') ? localStorage.getItem('role') : '',
        value: '',
        time: 10,
        intVal: ''
    }
  },
  methods: {
    ...mapGetters(['']),
    toStore(){
      this.$router.push({
        path: '/store',
        query: this.storage.filter(v => v.roleName == this.role)[0]
      })
    },
    toConsume(){
      this.$router.push({
        path: '/consume',
        query: this.storage.filter(v => v.roleName == this.role)[0]
      })
    }
  },
  computed:{
  },
  mounted(){
    // if(this.$route.query.orderStatus == 'success'){
    //   this.storage.map(v => {
    //     if(v.accessToken == window.localStorage.getItem('accessToken')){
    //       v.buyList = []
    //     }
    //     return v
    //   })
    //   window.localStorage.setItem('storage', JSON.stringify(this.storage))
    // }
    this.intVal = setInterval(() => {
      if(this.time > 1){
        this.time--
      } else {
        clearInterval(this.intVal)
        this.$router.push({
          path: '/store',
          query: this.storage.filter(v => v.roleName == this.role)[0]
        })
      }
    }, 1000)
  },
  beforeDestroy(){
    clearInterval(this.intVal)
  }
}
</script>

<style lang="scss">
.finish{
  margin: 10px;
  img{
    display: block;
    width: 20%;
    margin: 0 auto;
  }
  p{
    text-align: center;
    font-size: 10px;
    color: #9e9e9e;
    margin-top: 20px;
  }
  .van-button{
    height: 30px;
    margin: 0 auto;
    position: relative;
    display: block;
    line-height: 30px;
    text-align: center;
    width: 40%;
  }
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .login_tips{
      text-align: center;
      font-size: 14px;
      margin: 10px 0;
  }
  .van-button--large{
    width: calc(100% - 20px);
    height: 30px;
    font-size: 14px;
    border-radius: 15px;
  }
  .van-swipe-item{
    img{
      width: 100%;
    }
  }
  .van-password-input__security{
        li{
            background-color: #e9e9e9;
            border-radius: 6px;
            &.van-password-input__item--focus{
                background-color: #fff;
                border: 1px solid #e60012;
            }
        }
  }
  .van-button--large{
    width: calc(100% - 20px);
    height: 30px;
    font-size: 14px;
    border-radius: 15px;
  }
  .van-password-input__security{
      height: 45px;
  }
  .van-overlay{
    z-index: 101;
  }
}
</style>
